import React from 'react';
import { BusinessBankingSectionView } from './BusinessBankingSectionView';

export default function BusinessBankingSection() {

  const handleSignUp = () => {
    window.dispatchEvent(new CustomEvent('waya-open-download-popup'));
  };

  return (
    <BusinessBankingSectionView onSignUp={handleSignUp} />
  );
}

